<template>
  <van-tabbar
    v-model="activeIndex"
    active-color="#7e5678"
    :border="true"
    inactive-color="#979799"
  >
  <!-- 首页 -->
    <van-tabbar-item to="/">
      <span class="tab-label">{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img :src="props.active ? icon.active : icon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Mine">
      <span class="tab-label">{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <img :src="props.active ? icon2.active : icon2.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  props: {
    active: {
      type: Number,
      default: 0
    }
  },
		computed: {
			activeIndex: {
				get: function () {
					return this.active;
				},
				set: function () {
				}
			}
		},
  data() {
    return {
      show: false,
      icon: {
        active: '/img/footer/indexed.png',
        inactive: '/img/footer/index.png',
      },
      icon2: {
        active: '/img/footer/myed.png',
        inactive: '/img/footer/my.png',
      },
    };
  },
  methods: {},
  watch: {
  },
  created() {
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 48px;
.van-tabbar {
  height: @tabbar-height;
}
.van-tabbar-item__icon img {
  height: @tabbar-img;
}
// .van-tabbar-item {
//   font-size: 26px;
// }
// .tui {
//   width: 4rem;
//   height: 4rem!important;
//   margin-top: -7.333vw;
//   background-color: white;
//   border-radius: 50%;
//   border: 10px solid white;
//   z-index: 10;
// }
[class*="van-hairline"]::after {
  border: none !important;
}
.tab-label{
  font-size: 28px;
}



</style>
